<template>
  <vue-simplebar id="sign-in" class="panel">
    <h3 class="font-mdish wt-md align-center" v-if="!inline">Welcome back</h3>

    <form :class="{ loading }" class="form-section" @submit.prevent="login" id="login-form-gtm">
      <div class="alert danger" v-if="authMessage">
        <p>{{ authMessage }}</p>
      </div>

      <div class="form-group vanilla">
        <label for="sign-in-username"
          >Email address <span class="required">*</span></label
        >
        <input
          id="sign-in-username"
          type="text"
          v-model="auth.email"
          required
        />
      </div>

      <div class="form-group vanilla">
        <label for="sign-in-password"
          >Password <span class="required">*</span></label
        >
        <input
          id="sign-in-password"
          type="password"
          v-model="auth.password"
          required
        />
      </div>
      <div class="alert danger" v-if="initiate_stripe_msg">
        <p>{{ initiate_stripe_msg }}</p>
      </div>
      <div class="alert danger" v-if="error">
        <p>{{ error }}</p>
        <p><a href="/contact">Contact Us</a></p>
      </div>

      <div class="form-group vanilla submit">
        <loader-button
          type="submit"
          :loading="loading"
          label="Log In"
          class="primary block login-btn-gtm"
        ></loader-button>
      </div>
    </form>

    <div class="form-supporting align-center font-sm">
      <p>
        Forgot/Reset your
        <a
          @click="$parent.changeAuthMode({ id: 'forgot_password' })"
          class="interactive"
          >Password</a
        >?
      </p>
    </div>

    <social-login-buttons></social-login-buttons>
  </vue-simplebar>
</template>

<script>
import SocialLoginButtons from "./shared/SocialLoginButtons";

export default {
  components: {
    SocialLoginButtons,
  },
  props: {
    inline: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      auth: {
        email: "",
        password: "",
      },
      loading: false,
      error: null,
      initiate_stripe_msg: "",
    };
  },
  computed: {
    authMessage() {
      return this.$store.getters["user/authMessage"];
    },
  },
  methods: {
    displayNewTerms(response) {
      this.$store
        .dispatch("modals/show", {
          title: "New terms and conditions",
          type: "new-term-condition",
          headless: true,
          maskCanDismiss: false,
        })
        .then((result) => {
          if (response.data.user.type == "lister") {
            this.stripeMsg(response);
          } else {
            // And show our login panel
            this.$store.commit("user/dismissAuth");
            // If we can go back to where we left off, do so
            if (!this.inline) {
              if (this.$store.getters["account/canRevert"]) {
                this.$store.dispatch("account/commitMutation", {
                  mutation: "navigateToReversion",
                });
              } else {
                this.$store.dispatch("account/commitMutation", {
                  mutation: "open",
                  data: this.$store.getters["user/shouldCompleteProfile"],
                });
              }
            }

            this.$emit("loggedIn", response);

            this.$toasted.show(
              `Thanks ${response.data.user.first_name}, you've logged in successfully.`,
              {
                type: "success",
              }
            );
            if (this.$store.getters["user/shouldBeRedirectedToListingForm"]) {
              this.$store.dispatch("modals/showAddListing");
              this.$store.commit("account/hide", true);
              this.$store.commit(
                "user/setShouldBeRedirectedToListingForm",
                false
              );
            }
            if (this.$store.getters["user/shouldBeRedirectedToFindYourSpace"]) {
              this.$store.dispatch("findspace/show");
              this.$store.commit("account/hide", true);
              this.$store.commit(
                "user/setShouldBeRedirectedToFindYourSpace",
                false
              );
            }
            this.loading = false;
          }
        })
        .catch(() => {
          //   this.loading = false;
          //   this.$store.commit("user/dismissAuth");
        });
    },
    stripeMsg(response) {
      this.$store
        .dispatch("modals/show", {
          title: `Welcome ${response.data.user.first_name} !`,
          cancelLabel: "Cancel",
          confirmLabel: "Ok",
          confirmMessage: `
          <div class="box">
              <p> Thank you for joining us and completing the first part of your profile.</p> <br>
              <h3><strong>Next Step - Set your payment details</strong></h3>
            <p>Before you get to the fun part - listing your unique space - we need to confirm your details and make sure we
                can pay you. We use Stripe as our secure payment gateway. You’ll need to set up a Stripe account, and to do
                so
                you’ll be redirected to the Stripe site. Once you’re all set up, you’ll be redirected back to us to start
                listing!
            </p> <br>
            <h3><strong>What is Stripe?</strong></h3>
            <p> Stripe is an online credit card provider that has been audited by a PCI-certified auditor and is certified
                to
                PCI Service Provider Level 1. We accept credit card payments through Stripe for all bookings. When a booking
                is
                confirmed for your listing, we will send you a quote to accept and payment will be sent to you online via
                Stripe, prior to the use of your space.
            </p> <br>
            <h3><strong>Final Step</strong></h3>
            <p> Listing your amazing space!</p>
          </div>`,
          data: response,
        })
        .then(() => {
          this.initiate_stripe_msg = "Redirecting for Stripe account setup";
          this.$store.commit("user/dismissAuth");
          this.$store.commit("user/setShouldCompleteProfile", true);
          this.onboard();
        })
        .catch(() => {
          this.loading = false;
        });
    },
    login() {
      if (!this.loading) {
        this.error = null;
        this.initiate_stripe_msg = "";
        this.$store.commit("user/dismissAuthMessage");
        this.loading = true;

        axios
          .get("/sanctum/csrf-cookie")
          .then(() => {
            axios
              .post("/api/auth/login", this.auth)
              .then((response) => {
                // dd("user data",response.data.user);
                // Set token
                this.$store.commit("user/token", response.data.token);
                this.$store.dispatch("user/setAuthHeader");
                //this.$store.dispatch('user/silentRefreshTokenTimer')

                // Save our user details
                this.$store.commit("user/authenticated", response.data.user);
                const stored = localStorage.getItem(
                  "isCheckedNotShowNewTermsPopup"
                );

                // And show our login panel
                this.$store.commit("user/dismissAuth");
                // If we can go back to where we left off, do so
                if (!this.inline) {
                  if (this.$store.getters["account/canRevert"]) {
                    this.$store.dispatch("account/commitMutation", {
                      mutation: "navigateToReversion",
                    });
                  } else {
                    this.$store.dispatch("account/commitMutation", {
                      mutation: "open",
                      data: this.$store.getters["user/shouldCompleteProfile"],
                    });
                  }

                  this.$emit("loggedIn", response);

                  this.$toasted.show(
                    `Thanks ${response.data.user.first_name}, you've logged in successfully.`,
                    {
                      type: "success",
                    }
                  );
                  if (
                    this.$store.getters["user/shouldBeRedirectedToListingForm"]
                  ) {
                    this.$store.dispatch("modals/showAddListing");
                    this.$store.commit("account/hide", true);
                    this.$store.commit(
                      "user/setShouldBeRedirectedToListingForm",
                      false
                    );
                  }
                  if (this.$store.getters["user/shouldBeRedirectedToFindYourSpace"]) {
                    this.$store.commit("findspace/show");
                    this.$store.commit("account/hide", true);
                    this.$store.commit(
                      "user/setShouldBeRedirectedToFindYourSpace",
                      false
                    );
                  }
                  this.loading = false;

                  this.$store.dispatch("intercom/track", {
                    type: "Log In",
                  });
                  console.log('Intercom New: Log In');
                }
                // }
              })
              .catch((error) => {
                this.loginError(error);
                this.loading = false;
              })
              .then(() => {});
          })
          .catch((error) => {
            this.loginError(error);
            this.loading = false;
          })
          .then(() => {});
      }
    },
    async onboard() {
      await axios
        .get("/api/account/stripe-connect/account/onboard", {
          params: {
            redirect_to: null,
          },
        })
        .then((response) => {
          if (response.data.url) {
            return (window.location.href = response.data.url);
          }
          throw new Error("Invalid onboard link response");
        })
        .catch(() => {
          this.$toasted.show("Could not fetch Stripe connect onboard link", {
            type: "error",
          });
          this.loading = false;
        });
    },
    loginError(error) {
      this.$store.commit("user/dismissAuthMessage");

      if (error.response.status === 401 || error.response.status === 403) {
        this.auth.password = null;
        return (this.error = error.response.data);
      }

      if (typeof error.response.data.errors !== "undefined") {
        const k = Object.keys(error.response.data.errors)[0];
        return (this.error = error.response.data.errors[k][0]);
      }

      this.error =
        "We could not log you in at this time, please try again later.";
    },
  },
};
</script>
